export default __webpack_public_path__ + "static/media/bg.bab4fcad.png";